<div *ngIf="getControl().errors" class="invalid-feedback d-block">

    <div *ngIf="getControl().errors['noSSIMDateReference']">
        <i class="fas fa-exclamation-triangle" *ngIf="getControl().touched || onlyIcon" title="{{'common.errors.form.ssimDate.noSSIMDateReference' | translate}} ({{referenceKey | translate}}){{item ? '.&nbsp;' + item : ''}}"></i>
        <small *ngIf="getControl().touched && !onlyIcon">&nbsp;</small>
        <small *ngIf="!onlyIcon">{{'common.errors.form.ssimDate.noSSIMDateReference' | translate}} ({{referenceKey | translate}}){{item ? '.&nbsp;' + item : ''}}</small>
    </div>
    <div *ngIf="getControl().errors['noSSIMDateInReferenceInterval']">
        <i class="fas fa-exclamation-triangle" *ngIf="getControl().touched || onlyIcon" title="{{'common.errors.form.ssimDate.noSSIMDateInReferenceInterval' | translate}}{{referenceKey | translate}}{{item ? '.&nbsp;' + item : ''}}"></i>
        <small *ngIf="getControl().touched && !onlyIcon">&nbsp;</small>
        <small *ngIf="!onlyIcon">{{'common.errors.form.ssimDate.noSSIMDateInReferenceInterval' | translate}}
            {{referenceKey | translate}}{{item ? '.&nbsp;' + item : ''}}</small>
    </div>

    <app-form-error [form]="form" [controlName]="controlName" [required]="required" [interval]="interval"
                [item]="item" format="99aaa" [mustBeEmpty]="mustBeEmpty" [onlyIcon]="onlyIcon"></app-form-error>
</div>